import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ConnectionSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ConnectionSVG;
